import { render, staticRenderFns } from "./NavigateBackButton.vue?vue&type=template&id=2267d2de"
import script from "./NavigateBackButton.vue?vue&type=script&lang=ts"
export * from "./NavigateBackButton.vue?vue&type=script&lang=ts"
import style0 from "./NavigateBackButton.vue?vue&type=style&index=0&id=2267d2de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_cache-loader@4.1.0_webpack@5.99.9__css-loader@6.1_ko473ranhrs7k4xxmt54qgngle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports